<template>
  <list-page-shell>
    <template #filters>
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item :label="$t('projectListPage.keywordLabel')">
          <el-input
            v-model="filters.keyword"
            clearable
            :placeholder="$t('projectListPage.keywordPh')"
            style="width:220px;"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="filters.projectStatusCode" clearable :placeholder="$t('common.pleaseSelect')" style="width:140px;">
            <el-option v-for="o in projectStatusOptions" :key="o.value" :value="o.value" :label="o.label" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">{{ $t('common.search') }}</el-button>
          <el-button icon="el-icon-refresh" :disabled="loading" @click="handleReset">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table :data="list" border stripe v-loading="loading" style="width:100%;">
      <el-table-column prop="projectCode" :label="$t('grid.code')" min-width="120" show-overflow-tooltip />
      <el-table-column :label="$t('projectDetailPage.contractNo')" min-width="120" show-overflow-tooltip>
        <template slot-scope="s">{{ s.row.linkedContractNo || '—' }}</template>
      </el-table-column>
      <el-table-column :label="$t('projectListPage.customerCol')" min-width="132" show-overflow-tooltip>
        <template slot-scope="s">{{ s.row.linkedCustomerDisplayName || '—' }}</template>
      </el-table-column>
      <el-table-column :label="$t('projectListPage.customerPhoneCol')" min-width="118" show-overflow-tooltip>
        <template slot-scope="s">{{ s.row.linkedCustomerPhone || '—' }}</template>
      </el-table-column>
      <el-table-column prop="projectName" :label="$t('grid.name')" min-width="180" show-overflow-tooltip />
      <el-table-column :label="$t('common.status')" width="100">
        <template slot-scope="s">{{ labelProjectStatus(s.row.projectStatusCode) }}</template>
      </el-table-column>
      <el-table-column :label="$t('grid.totalUsd')" width="128" align="right">
        <template slot-scope="s">{{ formatUsd(s.row.revenueAmount) }}</template>
      </el-table-column>
      <el-table-column :label="$t('grid.profit')" width="120" align="right">
        <template slot-scope="s">{{ formatUsd(s.row.profitAmount) }}</template>
      </el-table-column>
      <el-table-column :label="$t('grid.owner')" min-width="110" show-overflow-tooltip>
        <template slot-scope="s">{{ s.row.assignedSalesUserName || '—' }}</template>
      </el-table-column>
      <el-table-column :label="$t('projectDetailPage.pm')" min-width="110" show-overflow-tooltip>
        <template slot-scope="s">{{ s.row.projectManagerUserName || '—' }}</template>
      </el-table-column>
      <el-table-column :label="$t('grid.createdAt')" min-width="158" show-overflow-tooltip>
        <template slot-scope="s">{{ formatDisplayDateTime(s.row.createdAt) || '—' }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.actions')" width="100" fixed="right">
        <template slot-scope="s">
          <el-button type="text" size="small" @click="goDetail(s.row.id)">{{ $t('common.details') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="list-pager">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :page-sizes="[10, 20, 50]"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNo"
        @size-change="onSizeChange"
        @current-change="p => { pageNo = p; load() }"
      />
    </div>
  </list-page-shell>
</template>

<script>
import ListPageShell from '@/components/ListPageShell.vue'
import { getProjectPage } from '@/api/project'
import { enumSelectOptions, labelProjectStatus } from '@/utils/crmLabels'
import { projectDetailLocation } from '@/utils/contractDetailNav'
import { formatUsd } from '@/utils/formatUsd'
import { formatDisplayDateTime } from '@/utils/formatDisplayDateTime'

export default {
  name: 'ProjectList',
  components: { ListPageShell },
  data() {
    return {
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      loading: false,
      filters: { keyword: '', projectStatusCode: null }
    }
  },
  computed: {
    projectStatusOptions() {
      void this.$locale
      return enumSelectOptions(this.$t, 'projectStatus', [1, 2, 3, 4])
    }
  },
  created() {
    this.load()
  },
  methods: {
    labelProjectStatus,
    formatUsd,
    formatDisplayDateTime,
    onSizeChange(size) {
      this.pageSize = size
      this.pageNo = 1
      this.load()
    },
    handleSearch() {
      this.pageNo = 1
      this.load()
    },
    handleReset() {
      this.filters = { keyword: '', projectStatusCode: null }
      this.pageNo = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const params = { pageNo: this.pageNo, pageSize: this.pageSize }
        const kw = (this.filters.keyword || '').trim()
        if (kw) params.keyword = kw
        if (this.filters.projectStatusCode != null && this.filters.projectStatusCode !== '') {
          params.projectStatusCode = this.filters.projectStatusCode
        }
        const r = await getProjectPage(params)
        const d = r.data || r
        this.list = d.records || []
        this.total = d.total || 0
      } finally {
        this.loading = false
      }
    },
    goDetail(id) {
      this.$router.push(projectDetailLocation(id, this.$route.fullPath))
    }
  }
}
</script>

<style scoped>
.list-pager {
  margin-top: 16px;
  text-align: right;
}
</style>
